// ----------------------------------------------------------------------

const REPLY_ID_RE = /^\[#msg-([^\]]+)\]\s*$/;

function getPreviewText(content) {
  if (!content) return '';

  const lines = String(content).split('\n');
  let i = 0;
  let hadReplyMarker = false;
  const quoteLines = [];

  if (lines[i] && REPLY_ID_RE.test(lines[i])) {
    hadReplyMarker = true;
    i += 1;
  }

  while (i < lines.length && lines[i]?.startsWith('>')) {
    quoteLines.push(lines[i].replace(/^>\s?/, ''));
    i += 1;
  }

  if (hadReplyMarker || quoteLines.length > 0) {
    if (lines[i] === '') {
      i += 1;
    }

    const replyBody = lines.slice(i).join('\n').trim();
    if (replyBody) return replyBody;

    const quotedBody = quoteLines.join(' ').trim();
    return quotedBody || 'Replied to a message';
  }

  return String(content);
}

export default function useGetNavItem({ conversation, currentUserId }) {
  const { unreadCount, messages = [], participants = [], lastMessage: conversationLastMessage, lastMessageTime, type, groupName } = conversation || {};

  // Convert currentUserId to string for consistent comparison
  const currentId = String(currentUserId);

  const isGroup = type === 'GROUP';

  const participantsInConversation = participants.filter(
    (participant) => String(participant.id) !== currentId
  );

  const group = isGroup || participantsInConversation.length > 1;

  const displayName = isGroup
    ? (groupName || 'Group Chat')
    : (participantsInConversation.map((participant) => participant.name).join(', ') || 'Unknown');

  // Safely get last message from messages array or from conversation's lastMessage
  const lastMessageFromArray = messages && messages.length > 0 ? messages[messages.length - 1] : null;

  // Determine last activity time - prefer message timestamp, then lastMessageTime, then fallback
  let lastActivity;
  if (lastMessageFromArray?.createdAt) {
    lastActivity = lastMessageFromArray.createdAt;
  } else if (lastMessageTime) {
    // lastMessageTime is in milliseconds from the API
    lastActivity = new Date(lastMessageTime).toISOString();
  } else if (conversationLastMessage?.timestamp) {
    lastActivity = new Date(conversationLastMessage.timestamp).toISOString();
  } else {
    lastActivity = null;
  }

  const hasOnlineInGroup = group
    ? participantsInConversation.map((item) => item.status).includes('online')
    : false;

  let displayText = '';

  // Use last message from array first, then fallback to conversation's lastMessage
  if (lastMessageFromArray) {
    const sender = String(lastMessageFromArray.senderId) === currentId ? 'You: ' : '';
    const message = lastMessageFromArray.contentType === 'image' ? 'Sent a photo' : getPreviewText(lastMessageFromArray.body);
    displayText = `${sender}${message}`;
  } else if (conversationLastMessage) {
    const sender = String(conversationLastMessage.senderId) === currentId ? 'You: ' : '';
    const message = conversationLastMessage.type === 'image' ? 'Sent a photo' : getPreviewText(conversationLastMessage.content);
    displayText = `${sender}${message}`;
  } else {
    displayText = 'No messages yet';
  }

  return {
    group,
    isGroup,
    unreadCount: unreadCount || 0,
    displayName,
    displayText,
    // For group chats, return all participants for avatar display; for 1-to-1, exclude current user
    participants: isGroup ? participants : participantsInConversation,
    lastActivity,
    hasOnlineInGroup,
  };
}
